import { toast } from "sonner";
import { addToCart } from "../../configs/cartSlice";
import { PROTECTED_ROUTES } from "../../routes/routes";

export default function handleBuy(
  dispatch,
  navigate,
  id,
  item,
  name,
  offer_price,
  offer_discount,
  price,
  principal_amount,
  course_banner,
  thumbnail,
  plan_id = ''
) {
  const userAuthenticated =
    sessionStorage.getItem("authenticated") === "1";

  if (!userAuthenticated) {
    toast(
      `You need to log in to purchase this ${item.replace("_", "")}`
    );
    return;
  }

  const finalPrice =
    offer_price === "0.00"
      ? parseInt(price, 10)
      : parseInt(offer_price, 10);

  const sellingPrice = principal_amount
    ? parseInt(principal_amount, 10)
    : 0;

  const cartData = {
    id,
    item,
    name,
    price: finalPrice,
    course_banner,
    thumbnail,
    sellingPrice,
    offer_discount,
    plan_id,
  };

  console.log("Adding cart data:", cartData);

  dispatch(addToCart(cartData));

  toast("⚠️ Do not refresh the page");

  navigate(PROTECTED_ROUTES?.buy);
}